<template>
  <div class="bto-sb-widget bto-sb-widget-prematch bto-sb-widget-horse-events">
    <div class="bto-sb-widget-title">
      <h3>{{t('HR.NextRaces')}}</h3>
      <div class="bto-sb-form-select">
        <select @change="onOrderByChange()" v-model="sortBy">
          <option value="number">{{t('Mobile.Number')}}</option>
          <option value="odds">{{t('Mobile.Odds')}}</option>
        </select>
        <div class="bto-sb-form-select-arrow"></div>
      </div>
    </div>
    <div class="bto-sb-widget-content">
      <div class="bto-sb-event-sports">
        <ul>
            <li v-if="horseRacingTab" :class="[{'bto-sb-event-sports-active': selectedSport === horseRacingSportId}]" @click="changeSport(horseRacingSportId)"><span class="bto-sb-sports-icon horseracing"></span><a>{{t('PUBLIC.HORSERACING')}}</a></li>
            <li v-if="greyhoundRacingTab" :class="[{'bto-sb-event-sports-active': selectedSport === greyhoundRacingSportId}]" @click="changeSport(greyhoundRacingSportId)"><span class="bto-sb-sports-icon greyhoundracing"></span><a>{{ t('GR.GreyhoundsRacing') }}</a></li>
        </ul>
      </div>
      <div class="bto-sb-event-sports bto-sb-event-sports-slide bto-sb-event-sports-country" ref="hrDiv">
        <div class="bto-sb-event-more-sports bto-sb-event-more-sports-left"><a @click="sideScroll('left')"></a></div>
        <ul ref="hrCategories">
          <li @click="changeCategory()" :class="{'bto-sb-event-sports-active' : selectedCategory.length === 0 }"><a>{{t('HR.All')}}</a></li>
          <li ref="hrCategoriesItems" v-for="(item,idx) in hrMenu" :key="idx" @click="changeCategory(item.cid)" :class="{'bto-sb-event-sports-active' : selectedCategory[0] === item.cid}">
            <span class="bto-sb-flag bto-sb-flag-oval" :class="item.ccss"></span>
            <a>{{item.cname}}</a>
          </li>
        </ul>
        <div class="bto-sb-event-more-sports bto-sb-event-more-sports-right"><a @click="sideScroll('right')"></a></div>
      </div>
      <div class="bto-sb-horse-wrap-events">
        <empty-state v-if="hrRaces.length === 0" 
         :message="t(loading ? 'Mobile.LoadingMore' :'HR.NoEvents')" 
         :hideShadow="loading ? true : false"  
         :icon-class="loading ? loadingSpinner : emptyStateIcon" />
        <ul class="bto-sb-horse-events-items" ref='itemWrapper'>
          <li class="bto-sb-horse-events-item" ref='sliderItems'  v-for="(item,idx) in hrRaces" :key="idx">
            <div class="bto-sb-horse-event">
              <div class="bto-sb-horse-event-header">
                <div class="bto-sb-horse-event-category">
                  <div class="bto-sb-horse-event-category-name">
                    <i class="bto-sb-flag" :class="item.categoryCss"></i>
                    <span>{{item.categoryName}}</span>
                  </div>
                </div>
             
                <div class="bto-sb-horse-event-title">
                  <h5><i>{{item.time}}</i>{{item.raceName}}</h5>
                  <div class="bto-sb-horse-event-race">
                    <span class="bto-sb-horse-event-race-info">{{getEachWayText(item)}}</span>
                    <span v-if="item.handicap === 'Yes'" class="bto-sb-horse-event-race-info">{{ t("HR.Handicap") }}</span>
                  </div>
                </div>
                <div class="bto-sb-horse-event-info">
                  <div class="bto-sb-horse-event-status"><span :class="`${getIconStatusClass(item.raceStatusId)}`">{{item.raceStatusName}}</span></div>
                  <div v-if="item.hasLiveStream" class="bto-sb-horse-event-live"><span class="bto-app-live-stream-o"></span></div>
                </div>
              </div>
              <empty-state v-if="item.matchOdds.length === 0" 
               :message="t('HR.NoEvents')" 
               :icon-class="emptyStateIcon" />
              <hr-race-odds v-for="(items,idx) in item.matchOdds.slice(0,3)" :key="idx" :runner="items" :status="item.raceStatusId" :selectedSport="selectedSport" :raceType="item.RaceType" :tournamentId ="`hr${item.tournamentId}`" />
              <div class="bto-sb-horse-event-footer" @click="openDetails(item.tournamentId,item.raceNumber)"><div class="bto-sb-horse-more-item">{{t('HR.ViewFull')}}</div></div>
            </div>
          </li>
        </ul>
        <div class="bto-sb-horse-events-control">
          <div class="bto-sb-horse-events-control-next"  @click="goToSlide(getPreviousN())"><span class="bto-app-arrow-left"></span></div>
          <div class="bto-sb-horse-events-control-prev"  @click="goToSlide(getNextN())"><span class="bto-app-arrow-right"></span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import HorseRacingRequestService from './hr-request-service';
  import HRMatchModel from '../category-horse-racing/hr-match-model';
  import { HORSE_RACING_STATUSES_CLASES, HORSE_RACING_TIME_FILTERS } from '../../../models/enums/horse-racing-const';
  import HRCategoryMenu from './hr-category-menu-service';
  import HrRaceOdds from '../category-horse-racing/hr-race-odds';
  import { EmptyState, ICON_CLASS } from '../../shared/empty-state';
  import { truncateString } from '../../../services/utils';
  import store from '../../../store';

  export default {
    name: "HorseRacingWidget",
    components: {
      HrRaceOdds,
      EmptyState,
    },
    data() {
      return {
        hrRaces: [],
        hrMenu: [],
        selectedCategory: [],
        sortBy: 'odds',
        currentSlide: 0,
        loading: false,
        apiInterval: null,
        selectedSport: null,
        loadingSpinner: ICON_CLASS.LOADING,
      };
    },
    props: {
      horseRacingTab: {
        type: Boolean,
        default: true,
        label: 'Show horse racing tab',
      },
      greyhoundRacingTab: {
        type: Boolean,
        default: true,
        label: 'Show greyhound racing tab',
      },
    },
    computed: {
      horseRacingSportId() {
        return store.state.SportsModule.hrSportId;
      },
      greyhoundRacingSportId() {
        return store.state.SportsModule.ghSportId;
      },
      emptyStateIcon() {
        if (this.selectedSport === this.horseRacingSportId) {
          return ICON_CLASS.HORSE;
        }
        return ICON_CLASS.GREYHOUND;
      },
    },
    watch: {
      horseRacingSportId: {
        handler(val) {
          if (val && this.hrMenu.length === 0) {
            this.selectedSport = this.getSelectedSport();
            this.fetchData();
            this.setApiInterval(this.selectedCategory);
          }
        },
        immediate: true,
      },
    },
    destroyed() {
      this.clearApiInterval();
    },
    methods: {
      getSelectedSport() {
        if (this.horseRacingTab) {
          return this.horseRacingSportId;
        } else if (!this.horseRacingTab && this.greyhoundRacingTab) {
          return this.greyhoundRacingSportId;
        } else {
          return this.greyhoundRacingSportId;
        }
      },
      changeSport(id) {
        // reset the left style whenever we change sport
        this.$refs.hrCategories.style.left = 0;
        this.selectedSport = id;
        this.fetchData();
        this.setApiInterval(this.selectedCategory);
      },
      setApiInterval(category = []) {
        this.clearApiInterval();
        this.apiInterval = setInterval(() => {
          this.getHRRaces(category, false);
        }, 30000);
      },
      clearApiInterval() {
        clearInterval(this.apiInterval);
      },
      fetchData() {
        this.getHRRaces(this.selectedCategory);
        const categoryMenuRequest = new HRCategoryMenu([this.selectedSport]);
        categoryMenuRequest.execute((response) => {
          this.hrMenu = response.data;
        });
      },
      changeCategory(cat) {
        const category = cat ? [cat] : [];
        this.selectedCategory = category;
        this.getHRRaces(category);
        this.setApiInterval(category);
      },
      onOrderByChange() {
        if (this.sortBy === 'number') {
          this.hrRaces.forEach(element => {
            element.matchOdds.sort((a, b) => (a.runnerNumber > b.runnerNumber ? 1 : -1));
          });
        } else {
          this.hrRaces.forEach(element => {
            element.matchOdds.sort((a, b) => {
              const aOut = (a.outcomes && a.outcomes[0] && (+a.outcomes[0].outcome)) || 0;
              const bOut = (b.outcomes && b.outcomes[0] && (+b.outcomes[0].outcome)) || 0;
              return aOut - bOut;
            });
          });
        }
      },
      getIconStatusClass(status) {
        return HORSE_RACING_STATUSES_CLASES[status] || '';
      },
      truncateString,
      getEachWayText(item) {
        return this.$translate.text('HR.EitherWay')
          .replace('{ewpLabel}', item.ewplabel)
          .replace('{ewpPlace}', item.eachWayPlaces);
      },
      getHRRaces(categoryID = [], showLoading = true) {
        const tournamentMatchesRequest = new HorseRacingRequestService([this.selectedSport], categoryID);
        if (showLoading) {
          this.hrRaces = [];
          this.loading = true;
        }
        tournamentMatchesRequest.execute((response) => {
          if (!showLoading && response.data.length === 0) {
            this.hrRaces = [];
          }
          let data = response.data.map(a => new HRMatchModel(a));
          this.hrRaces = data;
          this.onOrderByChange();
          this.goToSlide(0);
        }).finally(() => {
          this.loading = false;
        });
      },
      getNextN() {
        return this.currentSlide + 1 < (this.hrRaces.length - 1) ? this.currentSlide + 1 : 0;
      },
      openDetails(tournamentId, number) {
        this.$router.push({ name: 'raceDetailsHr', params: { sportId: `${this.selectedSport}`, raceId: `${tournamentId}`, raceDateFilter: HORSE_RACING_TIME_FILTERS.TODAY }, query: { rnum: number } });
      },
      getPreviousN() {
        return this.currentSlide - 1 >= 0 ? this.currentSlide - 1 : (this.hrRaces.length - 1) - 1;
      },
      goToSlide(n) {
        let slideWidth = this.$refs.sliderItems[0].getBoundingClientRect().width;
        this.$refs.itemWrapper.style.transform = `translateX(${-1 * slideWidth * n}px)`;
        this.$refs.itemWrapper.style.transition = 'all 0.4s ease-in-out 0s';
        this.currentSlide = n;
      },
      sideScroll(direction) {
        const hrDiv = this.$refs.hrDiv;
        const hrCategories = this.$refs.hrCategories;
        const hrCategoriesItems = this.$refs.hrCategoriesItems;
        // if the main div is bigger that categories then we dont need scroll.
        if (hrDiv.offsetWidth > hrCategories.offsetWidth) return;
        // current left position of the ul
        let currentPosition = parseInt(window.getComputedStyle(hrCategories).left);
        let lastItem = hrCategoriesItems[hrCategoriesItems.length - 1];

        if (direction === 'left' && currentPosition < 0) {
          currentPosition = Math.min(currentPosition + lastItem.offsetWidth, 0);
        } else if (direction === 'right' && currentPosition > -(hrCategories.offsetWidth - lastItem.offsetWidth)) {
          currentPosition = Math.max(currentPosition - lastItem.offsetWidth, -(hrCategories.offsetWidth - lastItem.offsetWidth));
        }
        // add current postion to the left property
        hrCategories.style.left = `${currentPosition}px`;
      }
    }
  };
</script>
